"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceHandler = void 0;
var react_1 = __importStar(require("react"));
var DowntimeOverlay_1 = require("./DowntimeOverlay");
var maintenanceService_1 = require("./maintenanceService");
var MaintenanceNotification_1 = require("./MaintenanceNotification");
exports.MaintenanceHandler = function (_a) {
    var fileApiUrl = _a.fileApiUrl, userId = _a.userId, tokenProvider = _a.tokenProvider, appId = _a.appId, _b = _a.dontShowLabel, dontShowLabel = _b === void 0 ? "Don't show again" : _b, _c = _a.colors, colors = _c === void 0 ? { primary: "#007ac1", secondary: "#03a9f4", text: "white" } : _c;
    var _d = react_1.useState(), activeMaintenance = _d[0], setActiveMaintenance = _d[1];
    var maintenanceService = maintenanceService_1.useMaintenanceService(fileApiUrl, userId, appId, tokenProvider);
    react_1.useEffect(function () {
        maintenanceService.getActive().then(setActiveMaintenance);
    }, [userId]);
    if (!activeMaintenance)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (maintenanceService_1.isMaintenanceDowntimeActive(activeMaintenance)) {
        return react_1.default.createElement(DowntimeOverlay_1.DowntimeOverlay, { maintenance: activeMaintenance });
    }
    else if (maintenanceService_1.isMaintenanceInNotificationPeriod(activeMaintenance)) {
        return (react_1.default.createElement(MaintenanceNotification_1.MaintenanceNotification, { colors: colors, dontShowLabel: dontShowLabel, onDontShowAgain: function () {
                maintenanceService.dontShowAgain(activeMaintenance.id, activeMaintenance.version);
            }, maintenance: activeMaintenance }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
